import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import gold from "../../../../../assets/icons/asset-icons/gold.svg";
import ps from "../../../../../assets/icons/asset-icons/profitsharing.svg";
import silver from "../../../../../assets/icons/asset-icons/silver.svg";
import Button from "../../../../common/Button/Button";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import TransactionTypeBadge from "../TransactionTypeBadge/TransactionTypeBadge";
import styles from "../Orders.module.scss";
import OrderDetails from "../../../../common/Modals/OrderDetails/OrderDetails";
import { getType } from "../Orders";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice, toFix } from "../../../../../utils/utils";
import { format } from "date-fns";
import { userSellWithUsAction } from "../../../../../features/user/userSlice";
import { cancelSellWithUsAction } from "../../../../../features/user/userSlice";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { useDebounce } from "../../../../customHook/useDebeunce";
import CancelOrder from "../../../../common/Modals/CancelOrder/CancelOrder";

const OpenedOrders = () => {
  const dispatch = useDispatch();
  const search = useOutletContext();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [imageURL, setImageURL] = useState("");
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [orderId, setOrderId] = useState({ orderId: "", transactionId: "" });

  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const debounced = useDebounce(search, 500);

  const fields = [
    { label: "Order ID" },
    { label: "Asset" },
    { label: "Type" },
    { label: "Qty", sort: true },
    { label: "Price", sort: true },
    { label: "Total" },
    { label: "Date", sort: true },
    { label: "Status" },
    { label: "Actions" },
  ];

  const getTransactions = async (data) => {
    setLoading(true);
    try {
      const params = {
        page: page,
        size: pageSize,
        // filterByStatus: "OPENED",
      };
      if (debounced) {
        params.searchKeyword = debounced;
      }
      if (data === "Qty") {
        params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      }
      if (data === "Date") {
        params.sortByDate = dateFilter == true ? "ASC" : "DESC";
      }
      if (data === "Price") {
        params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      }

      const response = await dispatch(userSellWithUsAction(params));
      if (response.status === 200) {
        setOrders(response.data.data.rows);

        setTotalPages(response?.data?.data?.totalPages);
        setImageURL(response.data.data.imageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const callBackOnClick = (data) => {
    if (data === "Qty") {
      setQuantityOrder((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
    if (data === "Price") {
      setPriceOrder((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
    if (data === "Date") {
      setDateFilter((prevIsTrue) => !prevIsTrue);
      getTransactions(data);
    }
  };

  const handleCancelSubmit = async () => {
    try {
      let dataObj = {
        orderId: selectedOrder,
      };
      const response = await dispatch(cancelSellWithUsAction(dataObj));
      if (response.status === 200) {
        setCancelModal(false);
        getTransactions();
      }
    } catch (error) {}
  };

  useEffect(() => {
    getTransactions();
  }, [page, debounced]);

  return (
    <>
      <Table
        noRecordContent={"No records for your search were found."}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        loading={loading}
        fields={fields}
        className={styles.table}
        onClick={callBackOnClick}
      >
        {orders?.length > 0 &&
          orders?.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <Tooltip
                    icon={<span>{item.order_uid}</span>}
                    content={
                      <>
                        <CopyBtn text={item.order_uid} /> {item.order_uid}
                      </>
                    }
                    className={styles.order_id}
                  />
                </td>
                <td className={styles.asset}>
                  <img
                    alt="asset"
                    src={`${imageURL}${item.master_tokens_configuration?.image}`}
                  />
                  {item.master_tokens_configuration?.name}
                </td>
                <td>
                  <TransactionTypeBadge type={getType(item.order_type)}>
                    {item.order_type?.toLowerCase()}
                  </TransactionTypeBadge>
                </td>
                <td>
                  {toFix(
                    Number(item?.quantity),
                    decimalLimit[item?.master_tokens_configuration?.name]
                  )}
                </td>
                <td>${formatPrice(Number(item?.price))}</td>
                <td>${formatPrice(Number(item?.price * item?.quantity))}</td>
                <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
                <td className="text-capitalize">
                  {item?.order_status?.toLowerCase()}
                </td>
                {/* <td>
                  <Button
                    variant="text_blue"
                    className={styles.detail_btn}
                    onClick={() => openDetailModal(item?.order_id, item?.id)}
                  >
                    Details
                  </Button>
                </td> */}
                <td>
                  {item?.order_status === "PENDING" ? (
                    <Button
                      text="Cancel"
                      onClick={() => {
                        setSelectedOrder(item?.order_uid);
                        setCancelModal(true);
                      }}
                    />
                  ) : (
                    <>-</>
                    // <Button
                    //   text="Details"
                    //   onClick={() => {
                    //     setSelectedOrder(item?.order_uid);
                    //     // setCancelModal(true);
                    //   }}
                    // />
                  )}
                </td>
              </tr>
            );
          })}
      </Table>
      {/* {transactions?.length > 0 && <Pagination pageCount={3} />} */}
      {orders?.length > 10 && (
        <Commonpagination
          // className={classpagonation}
          currentPage={page}
          totalPages={totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <OrderDetails
        show={show}
        handleClose={() => setShow(false)}
        orderId={orderId}
      />

      <CancelOrder
        show={cancelModal}
        handleClose={() => setCancelModal(false)}
        handleCancelSubmit={handleCancelSubmit}
      />
    </>
  );
};

export default OpenedOrders;
